import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import {
  downloadPdfService as downloadPdfServiceLKFL,
  downloadReceipt,
} from '../../../services/API';
import Warning from '../../../components/Warning';
import Loading from '../../../components/Loading';

import styles from './PreviewReceipt.module.scss';

const fileSaver = require('file-saver');
const DEFAULT_SCALE = 1.5;

export default class PreviewReceipt extends Component {
  static propTypes = {
    record: PropTypes.shape({
      receiptId: PropTypes.string.isRequired,
    }).isRequired,
    hasDownloadLink: PropTypes.bool,
    receiptBody: PropTypes.string,
    onFetchCompletion: PropTypes.func,
  };
  static defaultProps = {
    hasDownloadLink: true,
  };
  state = {
    loading: true,
    error: null,
    blob: null,
  };
  $pdfPreview = React.createRef();

  componentDidMount() {
    this.fetchAndDisplayDocument();
  }

  fetchAndDisplayDocument = async () => {
    const PDFJS = await import('pdfjs-dist');
    const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    await this.getByteArrayLKFL(PDFJS);
  };

  emitCompleted = (reqStatus) => {
    const { onFetchCompletion } = this.props;
    if (onFetchCompletion) {
      onFetchCompletion(reqStatus);
    }
  };

  getPreview = (page, container, scale = DEFAULT_SCALE) => {
    if (container) {
      const viewport = page.getViewport({ scale });

      let canvas = document.createElement('canvas');

      canvas.className = styles.canvas;
      container.appendChild(canvas);
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const context = canvas.getContext('2d');
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      page.render(renderContext);
    }
  };

  getByteArrayLKFL = async (PDFJS) => {
    try {
      const pdfData = await this.downLoadService();
      const blob = new Blob([pdfData], {
        type: 'application/pdf;charset=utf-8',
      });
      this.setState({
        loading: false,
        blob: blob,
      });
      const result = await PDFJS.getDocument(pdfData).promise;
      const page = await result.getPage(1);
      this.getPreview(page, this.$pdfPreview.current);
      this.emitCompleted(true);
    } catch (err) {
      this.setState({
        error: true,
        loading: false,
      });
    }
  };

  downLoadService = async () => {
    const {
      record: { receiptId },
      receiptBody,
    } = this.props;
    const res = await (receiptId
      ? downloadPdfServiceLKFL(`receipt/${receiptId}`)
      : downloadReceipt(receiptBody));
    if (!res.isOk) {
      this.emitCompleted(res.isOk);
      throw res.error;
    }
    return res.data;
  };

  downloadDocument = () => {
    try {
      fileSaver.saveAs(this.state.blob, 'filename', true);
    } catch (e) {
      this.setState({ error: true });
    }
  };

  renderPreview = () => {
    const { hasDownloadLink } = this.props;
    return (
      <>
        {hasDownloadLink && (
          <div className="page_margin30">
            <div className="link link_pdf">
              <a onClick={this.downloadDocument}>Сохранить в PDF</a>
            </div>
          </div>
        )}
        <div ref={this.$pdfPreview} className={styles.previewContainer} />
      </>
    );
  };

  render() {
    const { error, loading } = this.state;
    return (
      <div>
        {!loading && error ? <Warning message="Ошибка формирования документа." /> : null}
        {loading && !error ? <Loading /> : null}
        {!loading && !error ? this.renderPreview() : null}
      </div>
    );
  }
}
